import request from '@/utils/request';

/**
 *   获取升级应用版本列表
 * @method getPreReleaseList
 * @return { request } axsio请求封装
 */
export function getPreReleaseList(params) {
  return request({
    url: `/op/cunwappupgrades/page`,
    method: 'get',
    params: params
  });
}

/**
 *   获取升级白名单列表
 * @method getCunwappwhites
 * @return { request } axsio请求封装
 */
export function getCunwappwhites(params) {
  return request({
    url: `/op/cunwappwhites/get`,
    method: 'get',
    params: params
  });
}

/**
 *   获取升级添加白名单
 * @method getCunwappwhitesAdd
 * @return { request } axsio请求封装
 */
export function getCunwappwhitesAdd(params) {
  return request({
    url: `/op/cunwappwhites/create`,
    method: 'post',
    data: params
  });
}
/**
 *   家庭端-正式发布
 * @method getCunwappOfficiallaunch
 * @return { request } axsio请求封装
 */
export function getCunwappOfficiallaunch(params) {
  return request({
    url: `/op/cunwappupgrades/officiallaunch/${params.cunwAppId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

/**
 *   删除/禁用/启用应用升级
 * @method updateApplicationUpgradeStatus
 * @param  form
 * @return { request } axsio请求封装
 */
export function updateApplicationUpgradeStatusRom(form) {
  return request({
    url: `/op/cunwappupgrades/rom/batch-status`,
    method: 'post',
    data: form
  });
}

/**
 *  编辑升级应用版本信息
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function editApplicationVersionRom(id, form) {
  return request({
    url: `/op/cunwappupgrades/rom/${id}`,
    method: 'post',
    data: form
  });
}
